module.exports = __webpack_public_path__ + "assets/img/profile-video-active.d12c216e.svg";